import { BrandPageQueryObj } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { QueryParameters } from "@faire/web-api--source/routes/brand/brandToken";

export function brandPageQueryObjToBrandPageQueryParams(
  queryObj: BrandPageQueryObj
): Partial<QueryParameters> {
  return {
    ...queryObj,
    refP: queryObj.refP?.[0],
    refF: queryObj.refF?.[0],
    sortingHint: queryObj.sortingHint?.toString(),
    page: queryObj.page?.toString(),
    filters: queryObj.filters?.[0],
    scrollToGrid: queryObj.scrollToGrid?.toString(),
    collections: queryObj.collections?.toString(),
  };
}
